import React, { useEffect, useState } from "react";
import { StyledShopName, StyledTopPart } from "../Catalog/styled";
import {
  Avatar,
  Button,
  Divider,
  Grid,
  IconButton,
  InputAdornment,
  Slider,
  SvgIcon,
  TextField,
  Typography,
} from "@mui/material";
import {
  ArrowBack,
  ArrowForward,
  ConfirmationNumberOutlined,
  Create,
  FavoriteBorder,
  HelpOutlineOutlined,
  InfoOutlined,
  NavigateBefore,
  NotificationsNoneOutlined,
  Storefront,
} from "@mui/icons-material";
import { colors } from "../../theme/colors";
import { useNavigate } from "react-router-dom";
import {
  ProductWrapper,
  StyledCenteredLabelTextField,
  StyledTextField,
} from "../Shop/styled";
import {
  getInitials,
  sortArrayOfObjectsByProperty,
} from "../../utils/functions";
import {
  StyledCardAmount,
  StyledProductWrapper,
  StyledTitle,
} from "../Buy/styled";
import { ReactComponent as NotificationIcon } from "../../assets/svg/notification-active.svg";
import { ReactComponent as TicketIcon } from "../../assets/svg/ticket2-default.svg";
import { ReactComponent as HeartIcon } from "../../assets/svg/Trazado 19268.svg";

export default function RangedVoucher({ product }) {
  const navigate = useNavigate();
  const [buttonHover, setButtonHover] = useState(false);
  const [selectedVoucherIndex, setSelectedVoucherIndex] = useState(0);
  const [sortedProducts, setSortedProducts] = useState(
    product.sort(sortArrayOfObjectsByProperty)
  );
  const [voucherAmount, setVoucherAmount] = useState(product[0].minimumAmount);

  const handleVoucherAmountChange = (e) => {
    if (e.target.value < product[0].minimumAmount) {
      setVoucherAmount(product[0].minimumAmount);
    } else if (e.target.value > product[0].maximumAmount) {
      setVoucherAmount(product[0].maximumAmount);
    } else {
      setVoucherAmount(e.target.value);
    }
  };

  return (
    <>
      <div style={{ maxWidth: "85%", margin: "auto" }}>
        {/* <Divider sx={{ marginTop: "1rem", marginBottom: "1rem" }} /> */}

        <StyledTitle style={{ color: colors.primary, marginTop: "2rem" }}>
          {product.length === 1 ? "Ingresa un monto" : "Elige el monto"}
        </StyledTitle>

        <StyledProductWrapper container direction="column">
          <Grid item>
            <Grid container textAlign="start">
              <Grid item md={4} textAlign="start">
                {product[0].brandImage ? (
                  <Avatar
                    sx={{
                      width: 80,
                      height: 80,
                      margin: "0.5rem",
                      "@media screen and (max-width: 600px)": {
                        width: 40,
                        height: 40,
                      },
                    }}
                    src={product[0].brandImage}
                  />
                ) : (
                  <StyledShopName
                    style={{
                      width: 80,
                      height: 80,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      margin: "0.5rem auto auto 0.5rem",
                    }}
                  >
                    <span>{getInitials(product[0].partner)}</span>
                  </StyledShopName>
                )}
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            alignItems="center"
            justifyContent="center"
            textAlign="center"
          >
            <>
              <StyledCardAmount>
                {"Q "}
                {voucherAmount}
              </StyledCardAmount>
            </>
          </Grid>
        </StyledProductWrapper>
      </div>

      <div
        style={{
          maxWidth: "560px",
          margin: "2rem auto 0rem auto",
          textAlign: "center",
          width: "85vw",
        }}
      >
        <Grid
          style={{
            color: colors.secondary,
            textTransform: "capitalize",
            textAlign: "center",
            fontSize: "22px",
          }}
          container
          spacing={3}
          justifyContent="center"
          direction={"column"}
        >
          <Grid item>
            <StyledCenteredLabelTextField
              InputProps={{
                inputProps: {
                  style: {
                    marginLeft: "1rem",
                    color: colors.primary,
                    fontWeight: "bold",
                    fontSize: "1.25rem",
                  },
                },
                endAdornment: (
                  <InputAdornment position="end">
                    <Create />
                  </InputAdornment>
                ),
                startAdornment: (
                  <span style={{ color: colors.primary, fontSize: "1.25rem" }}>
                    Q
                  </span>
                ),
                notched: false,
              }}
              margin="normal"
              fullWidth
              id="totalAmount"
              type="number"
              InputLabelProps={{
                style: {
                  textAlign: "center",
                },
              }}
              label={`Monto Desde Q${product[0].minimumAmount} A Q${product[0].maximumAmount}`}
              value={voucherAmount}
              onChange={(e) => setVoucherAmount(e.target.value)}
              onBlur={handleVoucherAmountChange}
            />
          </Grid>
        </Grid>
        <Divider sx={{ marginTop: "2rem" }} />
        <Typography color="secondary" variant="h4" fontWeight="regular">
          <Grid container spacing={5} justifyContent="center">
            <Grid item>TOTAL A PAGAR</Grid>
            <Grid item>
              <strong>{`Q ${voucherAmount}`}</strong>
            </Grid>
          </Grid>
        </Typography>
      </div>

      <Button
        endIcon={buttonHover ? <ArrowForward color="secondary" /> : null}
        onMouseOver={() => setButtonHover(true)}
        onMouseOut={() => setButtonHover(false)}
        color={buttonHover ? "primary" : "secondary"}
        variant="contained"
        onClick={() => {
          window.scrollTo(0, 0);
          navigate(`../buy/${product[0].voucherId}?va=${voucherAmount}`);
        }}
        sx={{
          left: "50%",
          transform: "translateX(-50%)",
          width: "60%",
          paddingRight: buttonHover ? "10%" : "initial",
          transition: "padding 200ms",
          paddingTop: "0.5rem",
          paddingBottom: "0.5rem",
          marginTop: "1.5rem",
          maxWidth: "650px",
          "@media screen and (max-width: 450px)": {
            width: "85%",
          },
        }}
      >
        Siguiente
      </Button>

      <Grid
        container
        spacing={2}
        sx={{ width: "85%", margin: "auto", marginTop: "3rem" }}
        justifyContent="center"
      >
        {product[0].description && (
          <Grid
            item
            alignItems="center"
            gap={2}
            sm={8}
            md={8}
            lg={4}
            textAlign="start"
          >
            <div style={{ display: "flex", marginBottom: "2rem" }}>
              <InfoOutlined color="primary" fontSize="large" />
              <Typography variant="h3" marginLeft={"1rem"}>
                ¿Qué incluye?
              </Typography>
            </div>
            <div
              dangerouslySetInnerHTML={{
                __html: product[0].description,
              }}
            />
          </Grid>
        )}
        <Grid
          item
          alignItems="center"
          gap={2}
          sm={8}
          md={8}
          lg={4}
          textAlign="start"
        >
          <div style={{ display: "flex" }}>
            <HelpOutlineOutlined color="primary" fontSize="large" />
            <Typography variant="h3" marginBottom="2rem" marginLeft={"1rem"}>
              ¿Cómo funciona?
            </Typography>
          </div>
          <Grid container spacing={4} direction={"column"}>
            <Grid
              item
              display="flex"
              alignItems="center"
              gap={2}
              sm={12}
              textAlign="start"
            >
              <SvgIcon
                component={NotificationIcon}
                inheritViewBox
                sx={{ fontSize: "40px" }}
              />
              <Typography variant="body1">
                Elige lo que deseas enviarle a tu ser querido de marcas
                reconocidas.
              </Typography>
            </Grid>
            <Grid
              item
              display="flex"
              alignItems="center"
              gap={2}
              sm={12}
              textAlign="start"
            >
              <SvgIcon
                component={TicketIcon}
                inheritViewBox
                sx={{ fontSize: "40px" }}
              />
              <Typography variant="body1">
                Paga con tarjeta de crédito o débito a través de Ecosistema Bi.
              </Typography>
            </Grid>
            <Grid
              item
              display="flex"
              alignItems="center"
              gap={2}
              sm={12}
              textAlign="start"
            >
              <SvgIcon
                component={HeartIcon}
                inheritViewBox
                sx={{ fontSize: "40px" }}
              />
              <Typography variant="body1">
                Enviamos el vale a tus seres queridos por ti por mensaje de
                texto o correo electrónico.
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
